import noUiSlider from 'nouislider';
import wNumb from 'wnumb';

export default {
  init() {
    var priceFilter = $('.price-filter')
    if (priceFilter.length > 0) {
      noUiSlider.create(priceFilter.get(0), {
        start: [0, 300],
        connect: true,
        tooltips: true,
        format: wNumb({
          decimals: 0,
        }),
        range: {
            'min': 0,
            'max': 300,
        },
      });
    }

    $('.qty').attr('type','text');

    $('[data-increase-quantity]').click(function() {
      var qtyInput = $(this).siblings('.qty')
      qtyInput.val(parseInt(qtyInput.val()) + 1);
    });

    $('[data-decrease-quantity]').click(function() {
      var qtyInput = $(this).siblings('.qty');
      if ( qtyInput.val() && parseInt(qtyInput.val()) > 0 ) {
        qtyInput.val(parseInt(qtyInput.val()) - 1);
      }
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js